var exports = {
  "kL": "container__MqTgzE",
  "wx": "header__Z4ZBNs",
  "j4": "languageLabel__2XIEK4",
  "zQ": "codeWrapper__X8Xmv8",
  "IR": "codeHighlight__znGc9o",
  "Ie": "codeTextarea__Jc3nU3",
  "Y_": "containerFocusVisible__FNpyWd",
  "hd": "codeTextareaHighlighted__kIrg78",
  "yZ": "collapsed__T_NVnF",
  "aY": "headerButton__yeOZ9k",
};

module.exports = exports;
